import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import axios from "axios";

function ConversionRatesChart({ userId }) {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [maxValue, setMaxValue] = useState(0); // To store the max value for Y-axis

  const fetchTopCities = async () => {
    try {
      if (!userId) {
        setError("User details are missing. Unable to fetch pro_id.");
        return;
      }

      const response = await axios.get(
        `${
          import.meta.env.VITE_BACKEND_URL
        }/dash/dashboard-insights/top-cities?user_id=${userId}`
      );

      const responseData = response.data;

      if (responseData.success) {
        const formattedData = responseData.data.map((item) => ({
          name:
            item.city
              ?.trim()
              ?.toLowerCase()
              ?.replace(/\b\w/g, (c) => c.toUpperCase()) || "Unknown",
          state: item.state || "Unknown",
          rate: parseInt(item.total_properties, 10) || 0,
        }));

        // Calculate max value for Y-axis
        const maxRate = Math.max(...formattedData.map((item) => item.rate));
        const adjustedMaxValue =
          maxRate < 10 ? 10 : Math.ceil(maxRate / 10) * 10;

        setMaxValue(adjustedMaxValue);
        setData(formattedData);
      } else {
        setError(responseData.message || "Failed to fetch top cities.");
      }
    } catch (error) {
      console.error("Error fetching top cities:", error);
      setError("An error occurred while fetching top cities.");
    }
  };

  useEffect(() => {
    fetchTopCities();
  }, [userId]);

  if (error) {
    return <div style={{ color: "red" }}>Error: {error}</div>;
  }

  if (data.length === 0) {
    return <div>Loading data...</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis
          domain={[0, maxValue]}
          ticks={Array.from(
            { length: maxValue / 10 + 1 },
            (_, index) => index * 10 // Generate ticks dynamically at intervals of 10
          )}
        />
        <Tooltip
          content={({ active, payload }) => {
            if (active && payload && payload.length) {
              const { name, state, rate } = payload[0].payload;
              return (
                <div
                  style={{
                    background: "#fff",
                    border: "1px solid #ccc",
                    padding: "10px",
                  }}
                >
                  <p style={{ margin: 0 }}>
                    <strong>{name}</strong>, {state}
                  </p>
                  <p style={{ margin: 0 }}>Properties: {rate}</p>
                </div>
              );
            }
            return null;
          }}
        />
        <Bar dataKey="rate" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default ConversionRatesChart;
